import React from "react";

import AccountLayout from "../../components/AccountLayout";
import AppLayout from "../../components/AppLayout";
import {
  AccountSectionHeader,
  SectionContent,
} from "../../components/AccountLayout/styles";

function MyRewards() {
  return (
    <SectionContent>
      <AccountSectionHeader>My Rewards</AccountSectionHeader>
    </SectionContent>
  );
}

export default MyRewards;
